const parseBoolean = (value) => {
    switch (typeof value) {
    case 'boolean':
        return value;
    case 'undefined':
        return false;
    case 'object':
        return false;
    case 'string':
        switch (value.toLowerCase().trim()) {
        case 'true':
        case 'yes':
        case '1':
            return true;
        default:
            return false;
        }
    default:
        return false;
    }
};

export default parseBoolean;
